import React, { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'info' | 'danger';
  size?: 'sm' | 'md';
  className?: string;
}

export default function BadgeComponent({ 
  children, 
  variant = 'default', 
  size = 'md',
  className = '' 
}: BadgeProps) {
  const variants = {
    default: 'bg-[#F3F4F6] text-[#6B7280] border-[#E5E7EB]',
    success: 'bg-[#D1FAE5] text-[#065F46] border-[#A7F3D0]',
    warning: 'bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]',
    info: 'bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]',
    danger: 'bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
  };

  return (
    <span className={`inline-flex items-center font-medium border rounded-full ${variants[variant]} ${sizes[size]} ${className}`}>
      {children}
    </span>
  );
}
